



























import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';

@Component
export default class OrderDetailsDialog extends Vue {
  @Prop() title: string;
  @Prop({default: false}) textNo: string;
  @Prop({default: false}) textYes: string;

  @Emit() response(agree: boolean) {
    return agree;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.smAndDown;
  }
}
